import Component from '../abstracts/Component';
import vex from 'vex-js';
import {Select2Init} from '../utils/Select2Init';
import DatePickerComponent from './DatePickerComponent';

export default class ModalComponent extends Component {

  get SELECTORS() {
    return {
      trigger: '[data-modal]',
      container: '.vex',
      focusableEl: 'a, :input:not([type=hidden]), button, [tabindex], iframe, :input:not(.form-group__username)',
      datepicker: '.js-datepicker'
    }
  }

  get LIBRARIES_SELECTORS() {
    return {
      tab: '[data-tabs]',
      select: 'select',
      modules: '[data-modules]',
    }
  }

  get CLASSES () {
    return {
      canScroll: 'can-scroll'
    }
  }

  constructor() {
    super();
    this.focusableEl = $(this.SELECTORS.focusableEl);
    this.datePickerComponent = new DatePickerComponent;
  }

  modalAfterOpen(vexInstance, closeText, overflow) {
    let lang = this.datePickerComponent.getLocalization($('html').attr('lang'));
    this.datePickerComponent.initDatepicker(null, lang, this.SELECTORS.datepicker);
    if(vexInstance.rootEl.classList.contains('fast-address')){
      Select2Init();
    }
    $('select#shippingAddress\\.province').select2({
      resolve: 'width',
      minimumResultsForSearch: 1,
      containerCssClass: 'custom-dt-container',
      dropdownCssClass: 'custom-dt-dropdown',
    });
    $('select#billingAddress\\.province').select2({
      resolve: 'width',
      minimumResultsForSearch: 1,
      containerCssClass: 'custom-dt-container',
      dropdownCssClass: 'custom-dt-dropdown',
    });

    let $close =  $(vexInstance.closeEl);
    let $container = $(vexInstance.rootEl);
    let closeLabel = closeText;
    $($close).removeClass('vex-close');
    $($close).addClass('icon-close');

    if (closeText) {
      $close.text(closeLabel).addClass('cta-close')
    }

    if (overflow === 'auto') {
      $('body').addClass(this.CLASSES.canScroll);
    }

    let $tabs = $container.find(this.LIBRARIES_SELECTORS.tab);
    if ($tabs.length > 0) {
      this.moduleLoader.loadBootstrapJsComponentAndExecute("tab",
        (module) => {
          $(this.LIBRARIES_SELECTORS.tab).tab();
          this.log('Tab initialized');
        },
        (error) => {
          console.log("failed to load tabs ", error.stack);
        }
      )
    }

    //ADD ACCESSIBILITY PROPERTIES
    $container.attr('tabindex', -1).attr('role', 'dialog');
    $close.attr('role', 'button').attr('tabindex', 0);

    let $focusableEl = $container.find(this.SELECTORS.focusableEl);
    $focusableEl.first().focus();

    $close.off('keydown.Modals').on('keydown.Modals', function (e) {
      if (e.keyCode === 13) {
        // vex.close(vexInstance);
      }
    });

  }

  getRequestBody (el) {
    try {
      const body = el.data('body');
      return typeof body === "string" ? JSON.parse(el.data('body')) : body;
    } catch (e) {
      return {}
    }
  }

  openAjaxContent(el) {
    // var
    let ctx = this;
    let url = el.data('href') || el.attr('href');
    let title = el.data('title');
    let close = el.data('closeText');
    let overlayClass = el.data('overlayClass');
    let overflow = el.data('overflow');
    let dataEgonValidation = el.data('egonValidation');
    let dataType = el.data('type');
    let modules = el.data('modules');
    let method = el.data('method') || 'GET';
    let body = method.toUpperCase() === 'POST' ? this.getRequestBody(el) : null;
    if(url.includes('editaddressfast=true')){
      $('.edit-fast-address-cta').addClass('disabled');
      $('.section-boxed .actions').css('cursor', 'wait');
      $('.edit-fast-address-cta').css('pointer-events', 'none');
    }

    $.ajax({
      type: method,
      url: url,
      data: body,
      contentType: body ? "application/json; charset=utf-8" : undefined,
      dataType: dataType
    }).then(resp => {
      let chunked = $(resp).find('[data-ajax-chunk]');

      if (typeof resp !="object" && chunked.length) {
        resp = chunked.html();
      }

      vex.open({
        unsafeContent: this.wrappedContent(resp, title)[0].outerHTML,
        className: el.data('modalClass'),
        afterOpen: function() {
          $('.edit-fast-address-cta').removeClass('disabled');
          $('.section-boxed .actions').css('cursor', 'pointer');
          $('.edit-fast-address-cta').css('pointer-events', 'auto');
          setTimeout(function(){
            $('body').trigger("formInitializeAll");
          }, 1000);
          ctx.$emit(ctx.$customEvents.MODAL_EVENTS.afterOpen);
          ctx.modalAfterOpen(this, close, overflow);
          if (dataEgonValidation === true) {
            ctx.$emit(ctx.$customEvents.MODAL_EVENTS.egonValidation);
          }
          //modules dynamic import
          if (modules != undefined) {
            ctx.importDynamicComponents(modules);
          }
        },
        afterClose: function() {
          ctx.$emit(ctx.$customEvents.MODAL_EVENTS.afterClose, this);
          $('body').removeClass(ctx.CLASSES.canScroll);
        },
        overlayClassName: overlayClass
      });
    });
  }

  handleSelects(modal){
    //initialize select2 for modal with ajax content
    let options = {
      resolve: 'width',
      minimumResultsForSearch: -1,
      containerCssClass: 'custom-dt-container',
      dropdownCssClass: 'custom-dt-dropdown',
    }
    let selects = modal.querySelectorAll('select')
    if(selects){
      selects.forEach((s, i) => {
        if (s.id !== 'countries-select') {
          s.id = `${s.id}-${i}`
          $(s).select2(options);
        }
      })
     }
  }

  openStaticContent(el) {
    let ctx = this;
    let title = el.data('title');
    let close = el.data('closeText');
    let content = $(el.data('modalId'))[0].outerHTML;

    vex.open({
      unsafeContent: this.wrappedContent(content, title)[0].outerHTML,
      className: el.data('modalClass'),
      afterOpen: function() {
        ctx.$emit(ctx.$customEvents.MODAL_EVENTS.afterOpen);
        ctx.modalAfterOpen(this, close);
      },
      afterClose: function() {
        ctx.$emit(ctx.$customEvents.MODAL_EVENTS.afterClose, this);
        $('body').removeClass(ctx.CLASSES.canScroll);
      }
    });
  }

  openRemoteContent(conf) {
    let title = $(conf.unsafeContent).data('title');
    let close = $(conf.unsafeContent).data('closeText');
    const ctx = this;
    let classData = $(conf.unsafeContent).data('modalClass');
    if(conf.modalClass){
      classData = conf.modalClass ;
    }
    if (conf.canScroll) document.body.classList.add(this.CLASSES.canScroll);
    vex.open({
      unsafeContent: this.wrappedContent(conf.unsafeContent, title)[0].outerHTML,
      className: classData,
      afterOpen: function () {
        ctx.$emit(ctx.$customEvents.MODAL_EVENTS.afterOpen);
        ctx.modalAfterOpen(this, close);
      },
      afterClose: function () {
        ctx.$emit(ctx.$customEvents.MODAL_EVENTS.afterClose, this);
        $('body').removeClass(ctx.CLASSES.canScroll);
      }
    });
  }

  wrappedContent(content, title) {

    let container = $(`<div class="modal-content"></div>`);
    if (title) {
      let $header = $(`<div class="modal-header"><h2 class="h2-tertiary">${title}</div>`);
      container.append($header);
    } else {
      container.addClass('no-header')
    }
    if (content) {
      let $body = $(`<div class="modal-body">${content}</div>`);
      container.append($body);
    }
    return container;

  }

  importDynamicComponents(modulesList) {
    let ctx = this;
    let modules = modulesList.split(',');
    if (modules.length > 0) {
      modules.forEach(function (module) {
        ctx.importComponents(module)
          .then(({default: module}) => {
            let component = new module();
            component.render();
          })
          .catch(error => {
            console.error("Failed to load the component", error.stack);
          });
      });
    }
  }

  importComponents(componentName) {
    return import(/* webpackChunkName:`component-[request]` */ `../components/${componentName}`);
  }

  bindEvents() {

    this.$on('click.modal', ({event}) => {
      event.preventDefault();
      let $el = $(event.currentTarget);
      if ($el.data('modalId') ) {
        this.openStaticContent($el);
      } else {
        this.openAjaxContent($el);
      }
    }, 'body', this.SELECTORS.trigger);

    window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
        location.reload();
      }
    });

    // Modal when calling from outside
    this.$on(this.$customEvents.MODAL_EVENTS.show, ({payload}) => {
      this.openRemoteContent(payload);
    });

    //Modal
    this.$on(this.$customEvents.MODAL_EVENTS.afterOpen+'.mmfg '+this.$customEvents.MODAL_EVENTS.afterUpdateContent, () => {
      const modal = document.querySelector('.vex.c-edit-address');
      if (modal) this.handleSelects(modal);

    })

  }

  render() {
    this.bindEvents();
  }
}
